// extracted by mini-css-extract-plugin
export default {"contentInnerContainer":"tenant-view_contentInnerContainer__lM+lL","item":"tenant-view_item__1W7P8"};